import { render, staticRenderFns } from "./liveTill.vue?vue&type=template&id=5280b808&"
import script from "./liveTill.vue?vue&type=script&lang=js&"
export * from "./liveTill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports